<div class="modal-header warning wk-pcp__header">
    <h3 class="modal-title wk-pcp__header-title">{{ "FiltersSidebar.Events.PendingChangesTitle" | wkTranslate }}</h3>
    <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" class="wk-pcp__header-icon" />
</div>
<div class="modal-body wk-pcp__body">
    {{ "FiltersSidebar.Events.PendingConfirmationMessage" | wkTranslate }}
</div>
<div cg3-theme="PDS-v3" class="wk-pcp__actions">
    <button-field-pds3 type="primary" size="large" class="warning">
        <button type="button" (click)="discardChanges()">{{ "General.Discard" | wkTranslate }}</button>
    </button-field-pds3>
    <button-field-pds3 type="secondary" size="large" class="secondary">
        <button type="button" flow-id="secondary-button" (click)="keepEditing()">{{ "Settings.btnCancel" | translate }}</button>
    </button-field-pds3>
</div>
